import React from 'react';
export const ResetPassword = React.lazy(() => import('./ResetPassword'));